/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

/* ====================================================================
   BEHAVIOURS —> FADE ACCORDION
   ==================================================================== */

const instagramFeed = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'instagramFeed',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    logInit() {
      console.log(`${this.name}: Initialised`);
    },
    logEnabled() {
      console.log(`${this.name}: Enabled`);
    },
    logDestroyed() {
      console.log(`${this.name}: Destroyed`);
    },
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */
      /**
       * Expose the behaviour object for debugging
       */
      new InstagramFeed({
        username: 'NutriWolds',
        container: document.getElementById('instagramFeed'),
        display_profile: false,
        display_biography: false,
        display_gallery: true,
        callback: null,
        styling: true,
        items: 4,
        items_per_row: 4,
        margin: 1,
        lazy_load: true,
        on_error: console.error,
      });
    },
  },
);

export default instagramFeed;
